import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chargify/custom-ui-components';

import { DetailRow } from '../DetailRow';

export type Props = {
  /**
   * Trial expiration date
   */
  trialExpirationDate: string;
  /**
   * Next billing date
   */
  nextBillingDate: string;
  /**
   * Price after trial
   */
  priceAfterTrial: string;
  /**
   * Trial price
   */
  trialPrice: string;
};

const Trial = ({
  trialExpirationDate,
  nextBillingDate,
  priceAfterTrial,
  trialPrice,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.trial_price', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: trialPrice,
          color: 'success.main',
          fontWeight: 3,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.trial_expiration_date', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: trialExpirationDate,
          color: 'black.main',
          fontWeight: 0,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.price_after_trial', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: priceAfterTrial,
          color: 'success.main',
          fontWeight: 3,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.next_billing_date', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: nextBillingDate,
          color: 'black.main',
          fontWeight: 0,
        }}
      />
    </Box>
  );
};

export default Trial;
